import React, { useState } from 'react';
import { connect } from "react-redux";
import { compose } from "redux";
import { Redirect } from 'react-router-dom';
import Functions from '../../api/Functions';
import LinkCard from '../general/LinkCard';

function CallFunctions(props) {
  const [loading, setLoading] = useState(false);
  const { auth } = props;
  if (!auth.uid) return <Redirect to="/signin" />;

  const runFunction = (fbFunction) => {
    setLoading(true);
    fbFunction
      .then((response) => {
        console.log('runFunction:', response);
        setLoading (false);
      })
      .catch((e) => {
        setLoading(false);
        console.log('Error runFunction:', e.message);
      });
  };

  const cardCalculateUserCount = () => {
    return <LinkCard title='Calculate User Counters' actionText='Calculate' onClick={() => runFunction(Functions.calculateCurrentUsers())} />
  }

  return (
    <div className="container">
      <div className="title-section">Call Functions</div>
      {loading ? <h4>Processing...</h4>: <div/>}
      <div className="row">
        <div className="col l3 m6 s12">
          <div className="card horizontal">
            <div className="card-stacked">
              <div className="card-content">
                <p>Calculate Scores</p>
              </div>
              <div className="card-action">
                <a href="#calculateScores" onClick={() => runFunction(Functions.manualScoresCalculation())}>
                  Update Scores
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="col l3 m6 s12">
          <div className="card horizontal">
            <div className="card-stacked">
              <div className="card-content">
                <p>Update Ranking</p>
              </div>
              <div className="card-action">
                <a href="#updateRanking" onClick={() => runFunction(Functions.manualUpdateRanking())}>
                  Calculate Ranking
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="col l3 m6 s12">
          <div className="card horizontal">
            <div className="card-stacked">
              <div className="card-content">
                <p>Update Timezones</p>
              </div>
              <div className="card-action">
                <a href="#updateTimezones" onClick={() => runFunction(Functions.updateTimezones())}>
                  Update Timezones
                </a>
              </div>
            </div>
          </div>
        </div>
        {cardCalculateUserCount()}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    databases: state.firestore.ordered.databases,
    auth: state.firebase.auth,
  };
};

export default compose(
  connect(mapStateToProps)
)(CallFunctions);
